import React from 'react';
import global from '../../../styles/global.module.scss';
import { ChangeButton }from '../ChangeButton/ChangeButton';


interface ChangeButtonLayoutProps {
  stepNumber: number;
  firstCollectionHandle?: string;
  firstCollectionTitle?: string;
  secondCollectionHandle?: string;
  secondCollectionTitle?: string;
  productHandle?: string;
  productTitle?: string;
}

export const ChangeButtonLayout: React.FC<ChangeButtonLayoutProps> = ({ stepNumber, firstCollectionHandle, firstCollectionTitle, secondCollectionHandle, secondCollectionTitle, productHandle, productTitle }) => {
  // console.log('firstCollectionHandle:', firstCollectionHandle);
  // console.log('secondCollectionHandle:', secondCollectionHandle);
  // console.log('productHandle:', productHandle);
  const renderContent = () => {
    switch (stepNumber) {
      case 1:
        return (
          <div className={global.ChangeButtonLayout}>
            <ChangeButton to="/?step=1" category={firstCollectionTitle} stepNumber={1}/>
          </div>
        );
      case 2:
        return (
          <div className={global.ChangeButtonLayout}>
            <ChangeButton to="/?step=1" category={firstCollectionTitle} stepNumber={1}/>
            <ChangeButton to={`/?step=2&firstcollectionhandle=${firstCollectionHandle}`} category={secondCollectionTitle} stepNumber={2} />
          </div>
        );
      case 3:
        return (
          <div className={global.ChangeButtonLayout}>
            {firstCollectionHandle === 'first_other' && secondCollectionHandle === 'second_other' && productHandle === 'product_other' && (
              <>
                <ChangeButton
                  to={`/?step=1`}
                  category='その他'
                  stepNumber={1}
                  alertTrigger={true}
                />
                <ChangeButton
                  category='未設定'
                  stepNumber={2}
                />
                <ChangeButton
                  category='未設定'
                  stepNumber={3}
                />
              </>
            )}
            {firstCollectionHandle !== 'first_other' && secondCollectionHandle === 'second_other' && productHandle === 'product_other' && (
              <>
                <ChangeButton 
                  to={`/?step=1`} 
                  category={firstCollectionTitle}
                  stepNumber={1} 
                  alertTrigger={true}
                />
                <ChangeButton 
                  to={`/?step=2&firstcollectionhandle=${firstCollectionHandle}`} 
                  category='その他' 
                  stepNumber={2} 
                  alertTrigger={true}
                />
                <ChangeButton
                  category='未設定'
                  stepNumber={3}
                />
              </>
            )}
            {firstCollectionHandle !== 'first_other' && secondCollectionHandle !== 'second_other' && productHandle === 'product_other' && (
              <>
                <ChangeButton 
                  to={`/?step=1`} 
                  category={firstCollectionTitle}
                  stepNumber={1} 
                  alertTrigger={true}
                />
                <ChangeButton 
                  to={`/?step=2&firstcollectionhandle=${firstCollectionHandle}`} 
                  category={secondCollectionTitle}
                  stepNumber={2} 
                  alertTrigger={true}
                />
                <ChangeButton 
                  to={`/?step=3&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}`} 
                  category='その他' 
                  stepNumber={3} 
                  alertTrigger={true}
                /> 
              </>
            )}
            {firstCollectionHandle !== 'first_other' && secondCollectionHandle !== 'second_other' && productHandle !== 'product_other' && (
              <>
                {firstCollectionHandle !== 'suits_campaign' && (
                  <>
                    <ChangeButton 
                      to={`/?step=1`} 
                      category={firstCollectionTitle}
                      stepNumber={1} 
                      alertTrigger={true}
                    />
                    <ChangeButton 
                      to={`/?step=2&firstcollectionhandle=${firstCollectionHandle}`} 
                      category={secondCollectionTitle}
                      stepNumber={2} 
                      alertTrigger={true}
                    />
                  </>
                )}
                <ChangeButton 
                  to={`/?step=3&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}`} 
                  category={productTitle} 
                  stepNumber={3} 
                  alertTrigger={true}
                  firstcollectionhandle={firstCollectionHandle}
                />
              </>
            )}
          </div>
        );
      case 4:
        return (
          <div className={global.ChangeButtonLayout}>
            {firstCollectionHandle === 'first_other' && secondCollectionHandle === 'second_other' && productHandle === 'product_other' && (
              <>
                <ChangeButton
                  to={`/?step=1`}
                  category='その他'
                  stepNumber={1}
                  alertTrigger={true}
                />
                <ChangeButton
                  category='未設定'
                  stepNumber={2}
                />
                <ChangeButton
                  category='未設定'
                  stepNumber={3}
                />
                <ChangeButton
                  to={`/?step=4&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}&producthandle=${productHandle}`}
                  category="画像アップロード"
                  stepNumber={4}
                  alertTrigger={true}
                />
              </>
            )}
            {firstCollectionHandle !== 'first_other' && secondCollectionHandle === 'second_other' && productHandle === 'product_other' && (
              <>
                {firstCollectionHandle !== 'suits_campaign' && (
                  <>
                    <ChangeButton 
                      to={`/?step=1`} 
                      category={firstCollectionTitle}
                      stepNumber={1} 
                      alertTrigger={true}
                    />
                    <ChangeButton 
                      to={`/?step=2&firstcollectionhandle=${firstCollectionHandle}`} 
                      category="その他"
                      stepNumber={2} 
                      alertTrigger={true}
                    />
                  </>
                )}
                <ChangeButton
                  category='未設定'
                  stepNumber={3}
                  firstcollectionhandle={firstCollectionHandle}
                />
                <ChangeButton
                  to={`/?step=4&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}&producthandle=${productHandle}`}
                  category="画像アップロード"
                  stepNumber={4}
                  alertTrigger={true}
                  firstcollectionhandle={firstCollectionHandle}
                />
              </>
            )}
            {firstCollectionHandle !== 'first_other' && secondCollectionHandle !== 'second_other' && productHandle === 'product_other' && (
              <>
                <ChangeButton 
                  to={`/?step=1`} 
                  category={firstCollectionTitle}
                  stepNumber={1} 
                  alertTrigger={true}
                />
                <ChangeButton 
                  to={`/?step=2&firstcollectionhandle=${firstCollectionHandle}`} 
                  category={secondCollectionTitle}
                  stepNumber={2} 
                  alertTrigger={true}
                />
                <ChangeButton 
                  to={`/?step=3&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}`} 
                  category='その他' 
                  stepNumber={3} 
                  alertTrigger={true}
                />
                <ChangeButton
                  to={`/?step=4&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}&producthandle=${productHandle}`}
                  category="画像アップロード"
                  stepNumber={4}
                  alertTrigger={true}
                />
              </>
            )}
            {firstCollectionHandle !== 'first_other' && secondCollectionHandle !== 'second_other' && productHandle !== 'product_other' && (
              <>
                {firstCollectionHandle !== 'suits_campaign' && (
                  <>
                    <ChangeButton 
                      to={`/?step=1`} 
                      category={firstCollectionTitle} 
                      stepNumber={1} 
                      alertTrigger={true}
                    />
                    <ChangeButton 
                      to={`/?step=2&firstcollectionhandle=${firstCollectionHandle}`} 
                      category={secondCollectionTitle} 
                      stepNumber={2} 
                      alertTrigger={true}
                    />
                  </>
                )}
                <ChangeButton 
                  to={`/?step=3&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}`} 
                  category={productTitle} 
                  stepNumber={3} 
                  alertTrigger={true}
                  firstcollectionhandle={firstCollectionHandle}
                />
                <ChangeButton
                  to={`/?step=4&firstcollectionhandle=${firstCollectionHandle}&secondcollectionhandle=${secondCollectionHandle}&producthandle=${productHandle}`}
                  category="画像アップロード"
                  stepNumber={4}
                  alertTrigger={true}
                  firstcollectionhandle={firstCollectionHandle}
                />
              </>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      {renderContent()}
    </div>
  );
};